import { render, staticRenderFns } from "./SubEmpresaBlocoInformacaoSkeleton.vue?vue&type=template&id=89976cec&lang=pug"
import script from "./SubEmpresaBlocoInformacaoSkeleton.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoInformacaoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoInformacaoSkeleton.vue?vue&type=style&index=0&id=89976cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports